

class List{
    defaultOptions() {
        return {
        	'$container': null,
        	'onClickNext': null,
        	'mode': 'general',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.response = null;
        this.data = this.settings.data;
        this.needClear = true;

        this.initialize();
    }

    setNeedClear(value){
    	this.needClear = value;
    }

    initialize(){

    }

    setData(xhr){
    	this.response = xhr;
    	this.data = xhr.data;
    	this.build();
    }

    build(){
    	if(this.needClear){
	        this.$container
	        .html('');
			this.$list = $('<ul/>')
			.addClass('formation-list')
			.appendTo(this.$container);
	    }else{
	    	this.removeNextButton();
	    }

		for(var i in this.data){
			let item = this.data[i];

			let $item = this.buildItem(item);

			this.$list.append($item);
		}


		if(this.response.hasNext){
			if(this.settings.onClickNext){
				let $next = this.buildNextButton();
				this.$list.append($next);
			}
		}
    }

    buildItem(item){
    	let $item = $('<li/>')
		.addClass('formation-list-item');

        let period = item.periode;

        let price = parseFloat(item.PrixFormation);
        if(!price){
        	price = 'NC';
        }else{
        	price = window.formatFloat(price) + '&euro;';
        }

        let url = '/formation/detail?id='+item.Id;

        if(this.settings.mode == 'formation'){
        	url += '&back=/annuaire/formation/?id='+item.organisme.Id;
        }

        let $btnShow = $('<a/>')
        .attr('href',url)
        .addClass('btn btn-text btn-icon text-primary formation-btn')
        .append(
            "Voir d&eacute;tails"
        )
        .append(
        	$('<i/>')
        	.addClass('icon icon-plus')
    	)

        let subject = "["+item.title+"] "+item.diplome.TitreCourtDiplome;
        let urlContact = 'mailto:'+item.organisme.email+'?subject='+subject;
        let $btnContact = $('<a/>')
        .attr('href',urlContact)
        .addClass('btn btn-primary formation-contact-btn')
        .append("Contactez l'organisme");


		let colSizeFormation = 'col-lg-2 col-12';
		let colSizeDiplome = 'col-lg-2 col-12';
		let colSizePeriode = 'col-lg-2 col-12';
		let colSizeOrganisme = 'col-lg-2 col-12';
		let colSizePlace = 'col-lg-2 col-12';
		let colSizePrice = 'col-lg-2 col-12';
		let colSizeAction = 'col-lg-2 col-12';

        if(this.settings.mode == 'club'){
			colSizeFormation = 'col-lg-3 col-12';
			colSizePeriode = 'col-lg-3 col-12';
        }

        let $colFormation = $('<div/>')
		.addClass(colSizeFormation)
		.append(
			$('<div/>')
			.addClass('formation-number formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-number-icon')
				.addClass('icon icon-card')
			)
			.append(
				$('<div/>')
				.addClass('formation-number-label label')
				.attr('title',item.diplome.TitreDiplome)
				.append(item.diplome.TitreCourtDiplome)
			)
			.append(
				$('<div/>')
				.addClass('formation-number-value')
				.append(item.title)
			)
		);

		let $colDiplome = $('<div/>')
		.addClass(colSizeDiplome)
		.append(
			$('<div/>')
			.addClass('formation-number formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-number-icon')
				.addClass('icon icon-card')
			)
			.append(
				$('<div/>')
				.addClass('formation-number-label label')
				.append("Num&eacute;ro")
			)
			.append(
				$('<div/>')
				.addClass('formation-number-value')
				.append(item.title)
			)
		);


		let $colPeriode = $('<div/>')
		.addClass(colSizePeriode)
		.append(
			$('<div/>')
			.addClass('formation-period formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-period-icon')
				.addClass('icon icon-calendar')
			)
			.append(
				$('<div/>')
				.addClass('formation-period-label label')
				.append("Date(s)")
			)
			.append(
				$('<div/>')
				.addClass('formation-period-value')
				.append(period)
			)
		);

		let $colOrganisme = $('<div/>')
		.addClass(colSizeOrganisme)
		.append(
			$('<div/>')
			.addClass('formation-club formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-club-icon')
				.addClass('icon icon-club')
			)
			.append(
				$('<div/>')
				.addClass('formation-club-label label')
				.append("Club")
			)
			.append(
				$('<div/>')
				.addClass('formation-club-value')
				.append(item.organisme.label)
			)
		);

		let $colPlace = $('<div/>')
		.addClass(colSizePlace)
		.append(
			$('<div/>')
			.addClass('formation-place formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-place-icon')
				.addClass('icon icon-marker')
			)
			.append(
				$('<div/>')
				.addClass('formation-place-label label')
				.append("Lieu")
			)
			.append(
				$('<div/>')
				.addClass('formation-place-value')
				.append(item.LieuFormation)
			)
		);

		let $colPrice = $('<div/>')
		.addClass(colSizePrice)
		.append(
			$('<div/>')
			.addClass('formation-price formation-search-list__item')
			.append(
				$('<i/>')
				.addClass('formation-price-icon')
				.addClass('icon icon-prix')
			)
			.append(
				$('<div/>')
				.addClass('formation-price-label label')
				.append("Prix")
			)
			.append(
				$('<div/>')
				.addClass('formation-price-value')
				.append(price)
			)
		);

		let $colAction = $('<div/>')
		.addClass(colSizeAction)
		.append(
			$('<div/>')
			.addClass('formation-action')
			.append($btnShow)
		);

		let $rowFormation = $('<div/>')
		.addClass('formation')
		.addClass('row')
		.append(
			$colFormation
		)
		.append(
			$colPeriode
		);

		if(this.settings.mode == 'general'){
			$rowFormation
			.append(
				$colOrganisme
			)

		}

		$rowFormation
		.append(
			$colPlace
		)
		.append(
			$colPrice
		)
		.append(
			$colAction
		)

		$item.append($rowFormation);

		return $item;
    }

    removeNextButton(){
    	$('.formation-list-item-btn',this.$list).remove();
    }

    buildNextButton(){
    	var self = this;
    	let $item = $('<li/>')
		.addClass('formation-list-item formation-list-item-btn');

		let $btnNext = $('<button/>')
		.addClass('btn btn-primary btn-next')
		.attr('data-value',this.response.next)
		.append("Voir plus ("+this.response.remains+')')
		.on('click',function(){
			let $btn = $(this);
			$btn.attr('disabled','disabled');
			$btn.html('')
			.append(
				$('<i/>')
				.addClass('fa fa-spin fa-spinner')
			)
			self.settings.onClickNext($btn.data('value'))
		});

		$item.append($btnNext);

		return $item;

    }

    onShow(){

    }
}

module.exports = List;